import React from 'react';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-12 md:py-16 bg-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-96 h-96 bg-forest rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Small Label */}
        <div className="inline-block mb-6">
          <span className="text-forest font-semibold text-sm tracking-widest uppercase">Ready to Begin?</span>
          <div className="h-1 w-16 bg-forest mt-2 mx-auto"></div>
        </div>

        {/* Headline */}
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6 leading-tight">
          Let's capture your special moments together
        </h2>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-secondary mb-12 max-w-3xl mx-auto">
          Get your free quote today and let's create something beautiful
        </p>

        {/* CTA Buttons with Glassmorphism */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/contact" 
            className="group relative inline-flex items-center justify-center px-10 py-4 text-base font-semibold text-white rounded-full overflow-hidden transition-all duration-300 hover:scale-105 shadow-xl"
          >
            <div className="absolute inset-0 bg-forest group-hover:bg-secondary transition-colors duration-300"></div>
            <span className="relative z-10 flex items-center gap-2">
              Contact Form
              <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </span>
          </Link>

          <a 
            href="https://mail.google.com/mail/?view=cm&fs=1&to=jessecamarena008@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center justify-center px-10 py-4 text-base font-semibold text-forest rounded-full overflow-hidden transition-all duration-300 hover:scale-105 shadow-xl border-2 border-forest hover:border-secondary"
          >
            <div className="absolute inset-0 bg-white group-hover:bg-accent/20 transition-colors duration-300"></div>
            <span className="relative z-10 flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email Directly
            </span>
          </a>
        </div>

        {/* Trust Badge */}
        <div className="mt-12 flex items-center justify-center gap-2 text-secondary">
          <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          <span className="text-sm">Free consultation • Quick response • Professional service</span>
        </div>
      </div>
    </section>
  );
};

export default CTA;
